import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export const VerifyEmail = () => {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");
  const { refreshMe } = useAuth();

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("Missing token");
      return;
    }
    api
      .get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        setState("ok");
        refreshMe();
      })
      .catch((e) => {
        setState("error");
        setMsg(formatApiError(e));
      });
  }, [token, refreshMe]);

  return (
    <main className="min-h-[calc(100vh-4rem)] grid place-items-center px-6 py-12" data-testid="verify-email-page">
      <Card className="w-full max-w-md p-8 border border-slate-200 shadow-sm text-center">
        {state === "loading" && (
          <>
            <Loader2 className="w-10 h-10 text-slate-700 animate-spin mx-auto mb-4" />
            <p className="text-slate-600">{t("loading")}</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto mb-4" data-testid="verify-success-icon" />
            <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">
              {t("verify_email_success")}
            </h1>
            <Link to="/dashboard">
              <Button className="mt-4 bg-slate-900 hover:bg-slate-800" data-testid="verify-go-dashboard-btn">
                {t("nav_dashboard")}
              </Button>
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-600 mx-auto mb-4" data-testid="verify-error-icon" />
            <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">
              {t("verify_email_fail")}
            </h1>
            <p className="text-sm text-slate-600 mb-4">{msg}</p>
            <Link to="/login">
              <Button variant="outline" data-testid="verify-go-login-btn">
                {t("cta_login")}
              </Button>
            </Link>
          </>
        )}
      </Card>
    </main>
  );
};

export default VerifyEmail;
